export interface AdditionalTeacherSelectOption {
  id: string
  label?: string
  labelKey?: string
}

export enum TeacherOptionTypes {
  All = 'all-teachers',
  Current = 'current-teacher',
}
export const AllTeachersOption: AdditionalTeacherSelectOption = { id: TeacherOptionTypes.All, labelKey: 'teacher.all' }
export const CurrentTeacherOption: AdditionalTeacherSelectOption = {
  id: TeacherOptionTypes.Current,
  labelKey: 'teacher.myself',
}
